import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { getUserAlias } from 'models/ProfileInfo/selectors'
import { STRING } from 'resources'
import { deleteIcon } from 'resources/images'

import { updateReklaimProtectEmailAddress } from 'services/reklaimProtect'

import { OPEN_MODAL_KEYS } from '../constants'
import {
  EmailRowContainer,
  MoreIcon,
  More,
  Option,
  OptionIcon,
  OptionImg,
  Spacer,
  EmailText,
  PrimaryPill,
} from './styles'

const EmailRow = ({
  emailAddress,
  setOpenModalKey,
  setEmailAddressData,
  selectedEmailAddress,
  setSelectedEmailAddress,
}) => {
  const userAlias = useSelector(getUserAlias)
  const [showMore, setShowMore] = useState(false)

  const handleShowMore = useCallback(
    (emailAddressVal) => {
      setShowMore((prev) => !prev)
      setSelectedEmailAddress(emailAddressVal)
    },
    [setSelectedEmailAddress],
  )

  const handleMakePrimary = async () => {
    const result = await updateReklaimProtectEmailAddress(userAlias, {
      emailAddress: emailAddress.emailAddress,
    })
    if (result?.error) {
      return
    }

    setEmailAddressData((prevEmailAddresses) => {
      const index = prevEmailAddresses.findIndex((email) => email.emailAddress === emailAddress.emailAddress)
      if (index === -1) return prevEmailAddresses

      const cloned = [...prevEmailAddresses]
      const [newPrimary] = cloned.splice(index, 1)
      const updatedOthers = cloned.map((email) => ({ ...email, isPrimary: false }))
      return [{ ...newPrimary, isPrimary: true }, ...updatedOthers]
    })
    setShowMore(false)
  }
  const handleDelete = () => setOpenModalKey(OPEN_MODAL_KEYS.DELETE_EMAIL_ADDRESS)

  const options = [
    {
      label: STRING.protect.profileInfo.edit.emailAddresses.options.makePrimary,
      icon: <OptionIcon className="killi-icon-add" />,
      onClick: handleMakePrimary,
    },
    {
      label: STRING.protect.profileInfo.edit.emailAddresses.options.delete,
      icon: <OptionImg src={deleteIcon} />,
      onClick: handleDelete,
    },
  ]

  return (
    <EmailRowContainer>
      {showMore && selectedEmailAddress === emailAddress.emailAddress && (
        <More>
          {options.map((option) => (
            <Option key={option.label} onClick={option.onClick}>
              {option.icon}
              {option.label}
            </Option>
          ))}
        </More>
      )}
      <EmailText>{emailAddress.emailAddress}</EmailText>
      {emailAddress.isPrimary && (
        <PrimaryPill>{STRING.protect.profileInfo.edit.emailAddresses.primaryPill}</PrimaryPill>
      )}
      {!emailAddress.isPrimary && (
        <>
          <Spacer />
          <MoreIcon onClick={() => handleShowMore(emailAddress.emailAddress)} />
        </>
      )}
    </EmailRowContainer>
  )
}

EmailRow.propTypes = {
  emailAddress: PropTypes.shape({
    emailAddress: PropTypes.string.isRequired,
    isPrimary: PropTypes.bool.isRequired,
  }).isRequired,
  setOpenModalKey: PropTypes.func.isRequired,
  setEmailAddressData: PropTypes.func.isRequired,
  selectedEmailAddress: PropTypes.string,
  setSelectedEmailAddress: PropTypes.func.isRequired,
}

export default EmailRow
